module.exports = __webpack_public_path__ + "static/media/enterprenuarship.38264cb5.svg";